import { render } from "./OrganizationCard.vue?vue&type=template&id=e9173a20&scoped=true"
import script from "./OrganizationCard.vue?vue&type=script&lang=js"
export * from "./OrganizationCard.vue?vue&type=script&lang=js"

import "./OrganizationCard.vue?vue&type=style&index=0&id=e9173a20&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9173a20"]])

export default __exports__